module.exports = __webpack_public_path__ + "static/vid4-6d9518d9ef0c855eda6e9ec86425f240.mp4";